import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import "dayjs/locale/zh-cn";
import { zhCN } from "@mui/x-date-pickers/locales";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// 启用 UTC 和时区插件
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("zh-CN");

// 固定使用北京时间
dayjs.tz.setDefault("Asia/Shanghai");

export default function BasicDateTimePicker({ datetime, onChange }) {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="zh-cn"
      localeText={
        zhCN.components.MuiLocalizationProvider.defaultProps.localeText
      }
    >
      <DateTimePicker
        label="选择出生日期和时间（北京时间）"
        value={datetime}
        timezone="Asia/Shanghai"
        onChange={(value) => {
          // 将北京时间转换为 UTC 字符串发送到后端
          const utcString = value.utc().toISOString();
          console.log("北京时间:", value.format("YYYY-MM-DD HH:mm"));
          console.log("UTC:", utcString);
          onChange(value);
        }}
      />
    </LocalizationProvider>
  );
}
